import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { IoCloudUploadOutline, IoDocumentTextOutline } from "react-icons/io5";

const FileUpload = ({
  id,
  name,
  register,
  errors,
  title,
  accepts,
  placeholder,
  clearErrors,
  setValue,
  maxSize,
  maxFiles,
  initialValue,
  multiple,
}) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");

  const image_mime_types = ["image/jpeg", "image/gif", "image/png"];

  const { getRootProps, getInputProps } = useDropzone({
    accept: accepts,
    multiple: multiple,
    maxSize: maxSize,
    maxFiles: maxFiles,
    onDrop: (acceptedFiles, fileRejections) => {
      setError("");
      clearErrors(name);

      fileRejections.forEach((file) => {
        file.errors.forEach((error) => {
          if (error.code === "file-too-large") {
            var size = Math.floor(maxSize / (1024 * 1024));
            setError(`File is larger than ${size} MB`);
            return;
          }

          setError(error.message);
        });
      });

      setValue(name, acceptedFiles);

      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const thumbs = files.map((file) => {
    let preview = (
      <div className="w-32">
        <div className="flex items-center justify-center h-32 w-32 rounded-lg border p-1">
          <IoDocumentTextOutline className="text-3xl text-gray-400" />
        </div>
        <p className="text-xs overflow-ellipsis overflow-hidden mt-2 text-gray-400">
          {file.name}
        </p>
        <span
          className="text-red-500 cursor-pointer text-xs"
          onClick={() => handleRemove(file)}
        >
          Remove
        </span>
      </div>
    );

    if (image_mime_types.includes(file.type)) {
      preview = (
        <div className="w-32">
          <div className="h-32 w-32 rounded-lg border p-1">
            <img
              className="w-full h-full rounded"
              alt={file.name}
              src={file.preview}
            />
          </div>
          <p className="text-xs overflow-ellipsis overflow-hidden mt-2 text-gray-400">
            {file.name}
          </p>
          <span
            className="text-red-500 cursor-pointer text-xs"
            onClick={() => handleRemove(file)}
          >
            Remove
          </span>
        </div>
      );
    }

    return <div key={file.name}>{preview}</div>;
  });

  const handleRemove = (item) => {
    const new_files = files.filter((i) => i !== item);
    setFiles(new_files);
    setValue(name, new_files);
  };

  useEffect(() => {
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  useEffect(() => {
    if (initialValue) setFiles(initialValue);
  }, [initialValue]);

  return (
    <>
      <label className="form-label">{title}</label>
      <div className="border-2 border-dashed border-gray-300 rounded cursor-pointer">
        <div className="pl-3 pr-4 py-12 text-center bg-gray-50">
          <input id={id} name={name} {...register} {...getInputProps()} />
          {files.length === 0 && (
            <div
              {...getRootProps({
                className: "dropzone flex justify-center",
              })}
            >
              <div className="text-gray-400 text-sm">
                <IoCloudUploadOutline className="inline text-4xl" />
                <p className="mt-5 text-gray-500">
                  Choose a file or drag it here
                </p>
                <p className="text-xs text-gray-400">{placeholder}</p>
              </div>
            </div>
          )}
          {files.length !== 0 && (
            <div className="flex justify-center">
              <div className="flex space-x-5">{thumbs}</div>
            </div>
          )}
          <div className="pt-2">
            <span className="text-sm text-red-400">{error}</span>
          </div>
          {errors && errors[name] && (
            <div className="pt-2">
              <span className="text-sm text-red-400">
                {errors[name].message}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FileUpload;
